/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import _ from 'lodash';
import CheckBoxComponent from '../../../../../SharedModules/CheckBox/CheckBox';
import { getCopyTemplateByType } from '../../store/actions';
import SelectBoxWithoutBoxComponent from '../../../../../SharedModules/SelectBox/SelectBoxWithoutBox';

const CopyTemplateComp = (props) => {
  const { setLoading, onSelectRow, destinationRebate } = props;
  const dispatch = useDispatch();
  const [destData, setDestData] = React.useState({
    createNew: 0,
    rebateProgramCd: null,
    templateId: null,
  });
  const [destinationRebateList, setDestinationRebateList] = React.useState([]);
  const [templateList, setTemplateList] = React.useState([]);
  const [templateDropdownList, setTemplateDropdownList] = React.useState([]);
  const [viewCreateNew, setViewCreateNew] = React.useState(true);
  // const destinationRebate = useSelector(
  //   (state) => state.sharedState.LetterTemplateReducer.destinationRebate
  // );
  const letterTemplateList = useSelector(
    (state) => state.sharedState.LetterTemplateReducer.copyLetterTemplateList
  );
  const templeTypeList = useSelector(
    (state) => state.sharedState.LetterTemplateReducer.extraState.templeType
  );
  const letterTemplateDetail = useSelector(
    (state) =>
      state.sharedState.LetterTemplateReducer.letterTemplateDetail.searchValue
  );

  React.useEffect(() => {
    setLoading(false);
    if (!_.isEmpty(destinationRebate)) {
      const list = _.map(destinationRebate, (val, ind) => ({
        ...val,
        id: val.rebateProgramCd,
        name: `${val.rebateProgramCd} | ${val.shortDescr}`,
      }));
      setDestinationRebateList(list);
    }
  }, [destinationRebate]);

  React.useEffect(() => {
    if (letterTemplateDetail && letterTemplateDetail.rebateProgramCd) {
      const filter = {
        rebateProgramCd: letterTemplateDetail.rebateProgramCd,
        templateId: letterTemplateDetail.templateId,
      };
      setDestData({ ...filter, createNew: 0 });
      const list = {
        templateId: letterTemplateDetail.templateId,
        templateVersion: letterTemplateDetail.templateVersion,
      };
      setViewCreateNew(false);
      onSelectRow({ createNew: 0, list: list });
      dispatch(
        getCopyTemplateByType({
          rebateProgramCd: filter.rebateProgramCd,
          templateTypeCd: [letterTemplateDetail.templateTypeCd],
          // letterTemplateDetail.templateTypeCd === 'COVER'
          //   ? ['COVER']
          //   : templeTypeList,
        })
      );
    }
  }, [letterTemplateDetail]);

  React.useEffect(() => {
    setLoading(false);
    let newList = [];
    if (!_.isEmpty(letterTemplateList)) {
      if (
        letterTemplateList.message === 'SUCESS' &&
        letterTemplateList.status === '001'
      ) {
        const list =
          letterTemplateList.data || letterTemplateList.letterTemplate;
        if (!_.isEmpty(list) && list) {
          newList = _.map(list, (val) => ({
            ...val,
            id: val.templateId,
            name: val.name,
          }));
          newList = _.orderBy(newList, ['name'], ['asc']);

          if (
            destData.templateId &&
            destData.createNew === 0 &&
            destData.templateId === letterTemplateDetail.templateId
          ) {
            const match = _.find(list, { templateId: destData.templateId });
            if (match) {
              onSelectRow({
                createNew: 0,
                list: {
                  templateId: destData.templateId,
                  templateVersion: letterTemplateDetail.templateVersion,
                  maxTemplateVersion: match.templateVersion,
                },
              });
            }
          }
        }
        setTemplateList(list);
      }
    }
    setTemplateDropdownList(newList);
  }, [letterTemplateList]);

  const filterAction = (flType, data) => {
    const newData = { ...destData };
    newData[flType] = data;
    let list = null;
    if (flType === 'rebateProgramCd') {
      newData.templateId = -1;
      setLoading(true);
      dispatch(
        getCopyTemplateByType({
          rebateProgramCd: data,
          templateTypeCd: [letterTemplateDetail.templateTypeCd],
          // letterTemplateDetail.templateTypeCd === 'COVER'
          //   ? ['COVER']
          //   : templeTypeList,
        })
      );
    }
    if (flType === 'templateId' || flType === 'createNew') {
      const flData = flType === 'templateId' ? data : destData.templateId;
      if (flData !== -1) {
        // const crtNew = flType === 'createNew' ? data : destData.createNew;
        const list1 = _.filter(templateList, (l) => l.templateId === flData);
        list = list1[0];
        let viewCheck = false;
        if (list.templateId !== letterTemplateDetail.templateId) {
          newData.createNew = flType === 'createNew' ? newData.createNew : 0;
          viewCheck = true;
        }
        setViewCreateNew(viewCheck);
      }
    }
    if (list) {
      list = { ...list, maxTemplateVersion: list.templateVersion };
    }
    onSelectRow({ createNew: newData.createNew, list: list });
    setDestData({
      ...newData,
    });
  };

  return (
    <div
      className='lt-common-modal'
      data-testid='copy-letter-template-component'
    >
      <div className='p-3'>
        <fieldset className='selectBoxArea custom-fieldset'>
          <legend className='same-font-family'>Destination</legend>
          {viewCreateNew && (
            <CheckBoxComponent
              className='py-0 w-100 border-0'
              data-testid='create-new-template-check'
              labelName='Create New Template'
              defaultValue={destData.createNew === 1}
              filterAction={() =>
                filterAction('createNew', destData.createNew === 1 ? 0 : 1)
              }
            />
          )}
          <SelectBoxWithoutBoxComponent
            data-testid='destination-rebate-program-select-box'
            labelName=''
            required={false}
            select
            disabled={false}
            selectedOne={false}
            placeholder='Please Select One'
            optionList={destinationRebateList}
            defaultValue={destData.rebateProgramCd}
            filterAction={(e) => filterAction('rebateProgramCd', e)}
          />
          <SelectBoxWithoutBoxComponent
            data-testid='destination-template-list-select-box'
            labelName=''
            required={false}
            select
            disabled={false}
            selectedOne
            placeholder='Please Select One'
            optionList={templateDropdownList}
            defaultValue={destData.templateId}
            filterAction={(e) => filterAction('templateId', e)}
          />
        </fieldset>
      </div>
    </div>
  );
};
export default CopyTemplateComp;
